module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House25.4e2eb939.jpg";